import { Injectable } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http'
import { Observable } from 'rxjs'
import { AuthService } from 'src/app/features/auth/auth.service'
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Envio direto ao S3 já vai assinado na própria url: um Authorization nosso
    // faria a AWS recusar a requisição.
    if (request.url.includes('viacep') || request.url.includes('amazonaws.com')) {
      return next.handle(request)
    } else {
      // Não sobrescrever se já existe header Authorization (para tokens externos)
      if (request.headers.has('Authorization')) {
        return next.handle(request)
      }
      
      const token = this.authService.token;
      
      const duprequest = request.clone({
        headers: request.headers.set(
          'Authorization',
          'Bearer ' + token
        )
      })

      return next.handle(duprequest)
    }
  }
}
